import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesAddressesMain } from './modules/ui/Main';

const AddressesPage = (
  <SuspensePage>
    <PagesAddressesMain />
  </SuspensePage>
);

export default AddressesPage;
